import { listingQueryKeys as e } from "./useListingSearchQuery.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { listingsApi as n } from "@maat/api-main";
//#region src/listings/useListingsByIdsQuery.ts
var r = (r) => t({
	queryKey: e.byIds(r),
	queryFn: () => n.getListingsByIds(r),
	enabled: r.length > 0
});
//#endregion
export { r as useListingsByIdsQuery };
